export const LICENSE_LIST_PATH = '/product/category/license';

export function buildDefaultAccessMap(items, defaultValue) {
  return items.reduce((acc, item) => {
    acc[item.id] = defaultValue;
    return acc;
  }, {});
}

export function isAssignedProduct(accessMap, productId) {
  return Object.prototype.hasOwnProperty.call(accessMap, productId);
}

export function countCustomAccessByCategory(assignedProducts) {
  return assignedProducts.reduce((acc, product) => {
    if (!product?.categoryId) {
      return acc;
    }
    acc[product.categoryId] = (acc[product.categoryId] || 0) + 1;
    return acc;
  }, {});
}

export function formatCustomAccessLabel(count) {
  return `กำหนดเอง (${count})`;
}

export function deriveDrugLicensesByCategory(matrix) {
  const columns = matrix?.columns || [];
  const cells = matrix?.cells || {};
  const byCategory = {};

  columns.forEach((license) => {
    if (!license?.id || !license?.name) {
      return;
    }
    Object.keys(cells).forEach((categoryId) => {
      const access = cells[categoryId]?.[license.id];
      if (access !== 'buy-sell' && access !== 'buy-only' && access !== 'sell-only') {
        return;
      }
      if (!byCategory[categoryId]) {
        byCategory[categoryId] = [];
      }
      byCategory[categoryId].push(license.name);
    });
  });

  return byCategory;
}

export function attachDrugLicenses(
  rows,
  licensesByCategoryId,
  categoryIdKey = 'productcategory_id',
) {
  if (!Array.isArray(rows)) {
    return rows;
  }
  return rows.map((row) => {
    if (Array.isArray(row.drug_licenses)) {
      return row;
    }
    const categoryId = row[categoryIdKey];
    return {
      ...row,
      drug_licenses: licensesByCategoryId[categoryId] || [],
    };
  });
}
